import dayjs, { dateDisplayFormat, dateTimeDisplayFormat } from '~libs/dayjs';

import { Column, Row } from '~components/table-view';
import PrintToSignRecordActionButtons from '~support-at-home/components/budgets/print-to-sign/PrintToSignRecordActionButtons';

const formatDate = (value?: string | null) => (value ? dayjs(value).format(dateDisplayFormat) : '');

// Columns for the Print to Sign viewer (TAV-3313): one row per budget PDF printed for signing.
const printToSignRecordsColumns: Column[] = [
  {
    id: 'client',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'budget',
    header: 'Budget',
    caption: 'Budget reference and period',
    type: 'text',
    deriveValue: (row) => {
      const { reference, start_date: startDate, end_date: endDate } = row.budget ?? {};
      const period = startDate || endDate ? ` (${formatDate(startDate)} - ${formatDate(endDate)})` : '';
      return `${reference ?? ''}${period}`;
    },
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'requested_by',
    header: 'Requested By',
    caption: 'The user who pressed Print to Sign',
    type: 'text',
    deriveValue: (row) => row.requested_by?.full_name ?? '-',
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'requested_at',
    header: 'Requested At',
    type: 'text',
    deriveValue: (row) => (row.requested_at ? dayjs(row.requested_at).format(dateTimeDisplayFormat) : ''),
    classNames: {
      header: 'cell-align-left',
      column: 'cell-align-left',
    },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: PrintToSignRecordActionButtons,
    componentProps: (row: Row) => ({
      id: row.id,
      fileName: row.file_name,
    }),
  },
];

export default printToSignRecordsColumns;
